import React from 'react';
import { RefreshCw } from 'lucide-react';

const PullToRefreshIndicator = ({ pullDistance, isRefreshing, threshold = 80 }) => {
  const progress = Math.min(pullDistance / threshold, 1);
  const rotation = progress * 360;
  
  if (pullDistance <= 10 && !isRefreshing) return null;

  return (
    <div 
      className="md:hidden fixed left-0 right-0 flex justify-center z-50 pointer-events-none"
      style={{ 
        top: Math.max(60, pullDistance - 20),
        opacity: Math.min(1, pullDistance / 40)
      }}
    >
      <div className={`
        bg-white rounded-full p-3 shadow-lg border border-blue-200
        ${isRefreshing ? 'animate-pulse' : ''}
      `}>
        <RefreshCw 
          size={24} 
          className={`text-blue-600 transition-transform ${isRefreshing ? 'animate-spin' : ''}`}
          style={{ transform: isRefreshing ? undefined : `rotate(${rotation}deg)` }}
        />
      </div>
    </div>
  );
};

export default PullToRefreshIndicator;
